import { hot } from 'react-hot-loader/root';
import Component from './login-redux';

export default hot(Component);
